class WorkView {

    constructor(onOfficeTimeSelectionChangedFn,
                onOfficeMinutesSelectionChangedFn,
                onOfficeDaySelectionChangedFn,
                onFromHomeTimeSelectionChangedFn,
                onFromHomeMinutesSelectionChangedFn,
                onFromHomeDaySelectionChangedFn) {
        this.rootNode = $('.module--work');
        this.inOffice = new DayTimeDurationSelector(
            this.rootNode.find('.in-office-section'),
            onOfficeTimeSelectionChangedFn,
            onOfficeMinutesSelectionChangedFn,
            onOfficeDaySelectionChangedFn,
        );
        this.fromHome = new DayTimeDurationSelector(
            this.rootNode.find('.from-home-section'),
            onFromHomeTimeSelectionChangedFn,
            onFromHomeMinutesSelectionChangedFn,
            onFromHomeDaySelectionChangedFn,
        );
    }
}
